import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, XCircle } from 'lucide-react';
import { Button } from './ui/button';

export const WhySmartConnections = () => {
  const navigate = useNavigate();
  const traditionalIssues = [
    'Customers forget to leave reviews',
    'Complex review process',
    'No way to track engagement',
    'Missed review opportunities',
    'Difficult to collect feedback'
  ];

  const smartConnectionsBenefits = [
    'One-tap review access',
    'Instant QR code scanning',
    'Track review requests',
    'Professional presentation',
    'Boost your ratings'
  ];

  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-5xl font-extrabold text-navy mb-4">
            Why Review Standees?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            The easiest way to collect customer reviews
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-6">
          {/* Left Side - Traditional Problems */}
          <div className="bg-coral-custom rounded-[2.5rem] p-10">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-white rounded-2xl flex items-center justify-center">
                <XCircle className="w-7 h-7 text-red-500" />
              </div>
              <h3 className="text-3xl font-bold text-navy">
                Paper cards get lost
              </h3>
            </div>
            <ul className="space-y-3">
              {traditionalIssues.map((issue, index) => (
                <li key={index} className="flex items-start gap-3">
                  <XCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700 font-medium">{issue}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right Side - Smart Connections Benefits */}
          <div className="bg-dark-gray rounded-[2.5rem] p-10">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-white rounded-2xl flex items-center justify-center">
                <CheckCircle className="w-7 h-7 text-green-500" />
              </div>
              <h3 className="text-3xl font-bold text-white">
                Review Standees
              </h3>
            </div>
            <ul className="space-y-3 mb-8">
              {smartConnectionsBenefits.map((benefit, index) => (
                <li key={index} className="flex items-start gap-3">
                  <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" />
                  <span className="text-white font-medium">{benefit}</span>
                </li>
              ))}
            </ul>

            <Button 
              onClick={() => navigate('/shop')}
              className="bg-white text-navy hover:bg-gray-100 rounded-full px-8 py-4 text-lg font-semibold w-full"
            >
              Get My Standee
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
